import React, { useEffect, useState } from 'react';
import { ListProps } from './Handbooks.types';
import { Styled } from './Handbooks.styles';
import { Filters } from './components/Filters';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react';
import { ListItem } from './components/ListItem';
import { PageHeader } from '../components/PageHeader';
import { useHistory } from 'react-router';
import {
  BackButton,
} from '../components/NavigationButton';

import { getList as getListRequest, ITableRequest } from 'api/handbooks/table';
import { Page }                                     from '../components/Page';
import { apiTypes }                                 from 'shared/consts/handbooksApiTypes';

const getFilter = (
  config: any,
  sort: { field: string; direction: string },
  currentPage: number,
  filters: any
): ITableRequest => {
  return {
    schema: config.schema,
    table: config.table,
    fields: config.fields
      .filter((el: any) => !!el.name)
      .map((el: { name: string }) => el.name),
    sort,
    limit: config.elemsOnPage || 100,
    offset: (currentPage - 1) * (config.elemsOnPage || 100),
    filters,
    apiType: apiTypes.DEFAULT,
  };
};

export const HandbookList: React.FC<ListProps> = (props: ListProps) => {
  const config = props.config;
  const [sort, setSort] = useState(config.defaultSort);
  const [isPreloaderShown, showPreloader] = useState(false);
  const [list, setList] = useState([]);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState<string>('');

  const indexField = props.indexFieldName;
  const connections = props.connections;
  const history = useHistory();

  const reloadData = async () => {
    showPreloader(true);
    const data = await getListRequest(getFilter(config, sort, currentPage, filters));
    setList((data && data.list) || []);
    setCount((data && data.count) || 0);
    showPreloader(false);
  };

  useEffect(() => {
    reloadData();
  }, [props.type, filters, sort]);

  useEffect(() => {
    reloadData();
  }, [currentPage]);

  return (
    <Page title={config.title}
          primaryButtonNode={<BackButton onClick={() => history.push(`/handbooks`)} />}>
      <Filters
        config={config}
        pageCount={Math.ceil(count / config.elemsOnPage)}
        currentPage={currentPage}
        onPageChanged={(pageNumber: number) => setCurrentPage(pageNumber)}
        sort={sort}
        connections={connections}
        onSetFilter={(flt: string, srt: { field: string; direction: string}) => {
          setFilters(flt);
          setSort(srt);
        }}
      />
      {isPreloaderShown && (
        <Styled.Preloader>
          <Spinner size={SpinnerSize.large} />
        </Styled.Preloader>
      )}
      <Styled.List>
        {list.map((el: any) => (
          <ListItem
            indexFieldName={indexField}
            elem={el}
            config={config}
            connections={connections}
            type={props.type}
            key={`elem-${el[indexField]}`}
          />
        ))}
      </Styled.List>
    </Page>
  );
};
